// Datos compartidos del landing de Xavana Café.
// Centraliza el contenido real (productos, origen, segmentos de cliente, calidad)
// para que las distintas propuestas de landing (Home1/2/3) lo presenten sin duplicarlo.

export const URL_REGULACIONES =
  'https://www.gob.mx/agricultura/acciones-y-programas/sistema-nacional-de-informacion-del-cafe';

// --- Origen: Xicotepec de Juárez, Sierra Norte de Puebla ---
export const ORIGEN = {
  lugar: 'Xicotepec de Juárez, Puebla',
  region: 'Sierra Norte de Puebla',
  titulo: 'El café que nace entre la neblina',
  // Subtítulo del hero: máx. 20 palabras para no empujar el CTA fuera del viewport.
  heroSubtitulo:
    'Café de origen único cultivado bajo sombra en la Sierra Norte de Puebla, entre neblina y suelos volcánicos.',
  resumen:
    'Todo nuestro café proviene de Xicotepec de Juárez, en la Sierra Norte de Puebla: un Pueblo Mágico donde el café se cultiva bajo sombra, entre neblina constante y suelos de origen volcánico.',
  // Por qué importa Xicotepec (claims cualitativos, sin cifras inventadas)
  razones: [
    {
      titulo: 'Microclima de sierra',
      texto:
        'La neblina permanente y la lluvia abundante de la Sierra Norte maduran el grano lentamente, concentrando dulzor y acidez en la taza.',
    },
    {
      titulo: 'Cultivo bajo sombra',
      texto:
        'Se cultiva bajo el dosel del bosque tropical, lo que protege el suelo, la biodiversidad y da una taza más limpia y compleja.',
    },
    {
      titulo: 'Tradición cafetalera',
      texto:
        'Xicotepec es una de las zonas cafetaleras históricas de México; familias productoras —muchas de origen totonaca y náhuatl— han refinado el oficio por generaciones.',
    },
    {
      titulo: 'Arábica de altura media',
      texto:
        'Trabajamos principalmente variedades arábica de las laderas de la sierra, de fragancia fina, cuerpo óptimo y acidez brillante.',
    },
  ],
};

// --- Segmentos de cliente preferidos (B2B) ---
export const SEGMENTOS = [
  {
    id: 'cafeterias',
    nombre: 'Cafeterías',
    icono: 'mug-hot',
    promesa: 'Consistencia taza a taza',
    texto:
      'Perfiles estables para barra y métodos manuales, con abasto puntual para que nunca falte tu mezcla insignia.',
  },
  {
    id: 'restaurantes',
    nombre: 'Restaurantes',
    icono: 'utensils',
    promesa: 'El cierre perfecto de cada comida',
    texto:
      'Cafés de cuerpo y dulzor para sobremesa y espresso, con entregas que se ajustan a tu operación diaria.',
  },
  {
    id: 'hoteles',
    nombre: 'Hoteles',
    icono: 'hotel',
    promesa: 'Hospitalidad de origen mexicano',
    texto:
      'Volumen confiable para desayunos y habitaciones, con una historia de origen que enriquece la experiencia del huésped.',
  },
  {
    id: 'eventos',
    nombre: 'Eventos',
    icono: 'calendar-days',
    promesa: 'Café que está a la altura',
    texto:
      'Surtido para congresos, banquetes y activaciones, con capacidad de respuesta para picos de demanda sin agotados.',
  },
];

// --- Diferenciador operativo ---
export const LOGISTICA = {
  titulo: 'Política "Cero Agotados"',
  texto:
    'Operamos bajo logística exprés con entregas en menos de 24 horas y capacidad de surtir cualquier volumen en todo momento, brindando certeza operativa.',
};

// --- Pilares de control de calidad (cómo evaluamos el café) ---
export const PILARES_CALIDAD = [
  {
    titulo: 'El tamaño sí importa',
    texto:
      'La selección por tamaño es una de las primeras fases; los granos de primera calidad son los más grandes. Los rotos o con agujeros se descartan.',
  },
  {
    titulo: 'Café ¿100% puro?',
    texto:
      'Prueba rápida: al agregar una cucharada en agua, un grano de alta pureza no se disuelve velozmente. Si lo hace, contiene azúcares añadidos o mezclas secundarias.',
  },
  {
    titulo: 'Tipo de grano y morfología',
    texto:
      'Comercializamos principalmente Arábica (alargado, fragancia fina, acidez brillante y cuerpo óptimo) frente a variedades robustas de zonas bajas.',
  },
  {
    titulo: 'Tueste estratégico',
    texto:
      'El tueste libera aceites esenciales. Un tueste oscuro da consistencia y color profundo; uno medio mantiene la complejidad ácida y el dulzor de origen.',
  },
  {
    titulo: 'El molido perfecto',
    texto:
      'Un molido insuficiente bloquea la extracción; uno excesivo disuelve componentes amargos y se pierde la sutileza aromática.',
  },
];

// --- Tolerancia de defectos por criba de 350 g ---
export const DEFECTOS = [
  { tier: 'Mezcla Nacional', valor: '25', nota: 'Por cada 350 g' },
  { tier: 'Mezcla Americana', valor: '18', nota: 'Por cada 350 g' },
  { tier: 'Mezcla Europea', valor: '12', nota: 'Por cada 350 g' },
  { tier: 'De Especialidad', valor: '0', nota: 'Primarios · máx. 8 secundarios' },
];

// --- Catálogo de productos ---
export const VARIEDADES_CAFE = [
  {
    id: 'mezcla-nacional',
    nombre: 'Mezcla Nacional',
    precio: '$280',
    tipo: 'Mezcla Nacional',
    calidadExportacion: 'nacional',
    calidadTexto: 'Estándar Nacional (Consumo Local)',
    defectosTexto: 'Máximo 25 defectos por cada 350g de café.',
    eslogan: '"El goteo perfecto"',
    perfil: 'Notas de chocolate y frutos oscuros. Un clásico balanceado con cuerpo tradicional.',
    tueste: 'Medio-Oscuro',
    metodo: 'Goteo, cafetera de filtro o ducha tradicional.',
    perfilFiltro: 'fuerte',
    metodoFiltro: 'filtro',
    graficos: { cuerpo: 85, acidez: 40, dulzor: 60 },
  },
  {
    id: 'altura',
    nombre: 'Altura',
    precio: '$330',
    tipo: 'Europeo',
    calidadExportacion: 'americano',
    calidadTexto: 'Alta Sanidad / Preparación Americana',
    defectosTexto: 'Máximo 18 defectos por cada 350g de café.',
    eslogan: '"El perfecto equilibrio"',
    perfil: 'Mucho cuerpo, notas florales y cacao; sabor sumamente equilibrado y limpio.',
    tueste: 'Medio-Oscuro',
    metodo: 'Excelente en Goteo, Espresso y métodos profesionales de extracción.',
    perfilFiltro: 'balanceado',
    metodoFiltro: 'espresso',
    graficos: { cuerpo: 75, acidez: 55, dulzor: 70 },
  },
  {
    id: 'americano',
    nombre: 'Americano',
    precio: '$330',
    tipo: 'Mezcla Americana',
    calidadExportacion: 'americano',
    calidadTexto: 'Alta Sanidad / Preparación Americana',
    defectosTexto: 'Máximo 18 defectos por cada 350g de café.',
    eslogan: '"Acidez espectacular"',
    perfil: 'Taza limpia, perfil floral y frutal con notas pronunciadas a manzana y ciruela.',
    tueste: 'Medio',
    metodo: 'Optimizado para barra profesional y extracciones de espresso.',
    perfilFiltro: 'floral',
    metodoFiltro: 'espresso',
    graficos: { cuerpo: 50, acidez: 85, dulzor: 65 },
  },
  {
    id: 'europeo',
    nombre: 'Europeo',
    precio: '$370',
    tipo: 'Europeo',
    calidadExportacion: 'europeo',
    calidadTexto: 'Gourmet / Preparación Europea Estricta',
    defectosTexto: 'Máximo 12 defectos por cada 350g de café.',
    eslogan: '"Selección de excelencia"',
    perfil: 'Complejos olores florales, sabores frutales claros y mucho cuerpo. Selección estricta.',
    tueste: 'Medio',
    metodo: 'Brilla en V60, extracciones de Espresso y AeroPress.',
    perfilFiltro: 'balanceado',
    metodoFiltro: 'manual',
    graficos: { cuerpo: 80, acidez: 65, dulzor: 75 },
  },
  {
    id: 'descafeinado',
    nombre: 'Descafeinado',
    tipo: 'Mezcla Americana',
    precio: '$370',
    calidadExportacion: 'americano',
    calidadTexto: 'Alta Sanidad / Preparación Americana',
    defectosTexto: 'Máximo 18 defectos por cada 350g de café.',
    eslogan: '"Calidad 100% Arábica"',
    perfil: 'Mantiene la integridad física y sabor del grano premium sin los efectos de la cafeína.',
    tueste: 'Medio',
    metodo: 'Uso general, ideal para filtros de oficina o consumo saludable.',
    perfilFiltro: 'balanceado',
    metodoFiltro: 'filtro',
    graficos: { cuerpo: 60, acidez: 50, dulzor: 60 },
  },
  {
    id: 'especialidad-puebla',
    nombre: 'Especialidad Puebla',
    precio: '$460',
    tipo: 'De Especialidad',
    calidadExportacion: 'especialidad',
    calidadTexto: 'Café de Especialidad Certificado',
    defectosTexto: '0 defectos primarios y máx. 8 defectos secundarios por cada 350g.',
    eslogan: '"Excelencia floral y premiada"',
    perfil: 'Grano rigurosamente seleccionado con notas dulces a miel. Avalado con 85.25 puntos de cata certificado.',
    tueste: 'Medio',
    metodo: 'Exclusivo para métodos manuales de alta exigencia (Chemex, V60, Prensa Francesa).',
    perfilFiltro: 'floral',
    metodoFiltro: 'manual',
    graficos: { cuerpo: 55, acidez: 80, dulzor: 90 },
  },
];

// Paleta de marca (para referencia en las propuestas)
export const MARCA = {
  verde: '#2E5B2E',
  verdeOscuro: '#1F3F1F',
  bronce: '#8A5A2B', // dorado para texto/CTA sobre claro (AA)
  dorado: '#C19A6B', // decorativo / sobre fondo oscuro
  tinta: '#333333',
  claro: '#F9F9F5',
};

// Imágenes de origen/ambiente (Unsplash). Para proposals; en producción conviene self-host.
export const IMAGENES = {
  heroGranos:
    'https://images.unsplash.com/photo-1447933601403-0c6688de566e?q=80&w=2000&auto=format&fit=crop',
  sierraNeblina:
    'https://images.unsplash.com/photo-1444465693019-aa0b6392460d?q=80&w=2000&auto=format&fit=crop',
  baristaTaza:
    'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?q=80&w=2000&auto=format&fit=crop',
  granoMano:
    'Cafeto-planta-del-Cafe.jpg',
  restauranteMesa:
    'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=2000&auto=format&fit=crop',
};
